import React from 'react';
import {
  FaBalanceScale,
  FaFilePdf,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import PdfViewer from './PdfViewer';
import './CharteSection.css';

const PDF_URL = `${process.env.PUBLIC_URL || ''}/charte-marocaine-2025.pdf`;

const CharteSection = () => {
  return (
    <section className="charte-section">
      <div className="container">
        <div className="charte-wrapper">
          {/* TEXT COLUMN (left) */}
          <div className="charte-text-col">
            <div className="icon-wrapper">
              <FaBalanceScale />
            </div>
            <h2>
              Nouvelle version de la{' '}
              <span className="highlight">Charte marocaine</span> de l'expertise
              immobilière
            </h2>
            <div className="divider-line"></div>

            <p className="lead-intro">
              La nouvelle version de la Charte marocaine de l'expertise
              immobilière a récemment été publiée, consolidant le cadre de
              référence national en matière de rigueur méthodologique, d'éthique
              professionnelle et de qualité des pratiques dans le domaine de
              l'évaluation et du conseil immobilier au Maroc.
            </p>
            <p>
              Dans ce cadre, la direction d'<strong>ATAA REALTY</strong> a pris
              part aux travaux d'élaboration de cette version, contribuant aux
              réflexions visant à renforcer l'alignement des pratiques
              nationales avec les standards internationaux et à promouvoir une
              culture de responsabilité et de structuration durable de la
              profession.
            </p>

            <div className="charte-actions">
              <a
                href={PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="charte-action-btn primary"
              >
                <FaFilePdf /> Ouvrir le PDF
              </a>
              <a
                href={PDF_URL}
                download="Charte-marocaine-expertise-immobiliere-2025.pdf"
                className="charte-action-btn secondary"
              >
                <FaExternalLinkAlt /> Télécharger
              </a>
            </div>
          </div>

          {/* PDF VIEWER COLUMN (right) — shared component */}
          <div className="charte-pdf-host">
            <PdfViewer
              url={PDF_URL}
              ariaLabel="Visionneuse PDF de la Charte marocaine de l'expertise immobilière"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CharteSection;
